module.exports = __webpack_public_path__ + "media/images/signup_bg_desktop-e2eeb1a9.png";